// HR / Školení, záložka Školení (15. 10. 2026, schválený mockup): videa, prezentace
// a dokumenty po kategoriích, každé má vlastní přidělené lidi a je vidět, kdo má hotovo.
// Ke školení jde připojit test, přidělenému se nabídne po dokončení (/api/skoleni-materialy).
import React, { useEffect, useMemo, useState } from "react";
import { Play, Presentation, FileText, Plus, Check, Search, UserPlus, GraduationCap, ArrowUpRight, List } from "lucide-react";
import { useApiData, apiFetch } from "../../lib/api.js";
import { Modal, HlavickaOkna, EmptyState, KartaSeznam, PruhFiltru, RozbalovaciVyber, Stitek } from "../../components/ui.jsx";
import { Pil } from "../../components/sales/salesUi.jsx";
import { datumCz } from "../../components/SkoleniKarta.jsx";
import { useUzkaObrazovka } from "../../lib/obrazovka.js";
import SkoleniOkno from "../../components/SkoleniOkno.jsx";
import { slozModuly } from "../../lib/skoleniVideo.js";
import { toast } from "../../components/Toast.jsx";
import { confirmDialog } from "../../components/confirmHost.jsx";

export const IKONA_TYPU = { video: Play, prezentace: Presentation, dokument: FileText };
export const TYP_PIL = { video: { text: "video", ton: "info" }, prezentace: { text: "prezentace", ton: "znacka" }, dokument: { text: "dokument", ton: "neutralni" } };
const POPISEK = "mb-1.5 block text-[13px] font-bold text-slate-700";

/** Velký přepínač Školení / Testy (schválený mockup): dvě dlaždice, vybraná tmavá. */
export function PrepinacDlazdice({ polozky, hodnota, onChange }) {
  // Tři a více dlaždic se na mobilu nevejde vedle sebe s popisem: ikona nad název, popisek až od sm (Michal, 25. 10. 2026).
  const kompakt = polozky.length > 2;
  return (
    <div className="flex gap-2 sm:gap-3" role="group" aria-label="Sekce">
      {polozky.map((p) => {
        const zap = hodnota === p.key;
        const Ikona = p.ikona;
        return (
          <button key={p.key} type="button" aria-pressed={zap} onClick={() => onChange(p.key)}
            className={`flex min-h-[72px] min-w-0 flex-1 items-center rounded-2xl border shadow-glass transition ${kompakt ? "flex-col justify-center gap-1.5 px-1 py-2 text-center sm:flex-row sm:justify-start sm:gap-3 sm:p-3 sm:text-left" : "gap-3 p-3 text-left"} ${zap ? "border-brand-900 bg-brand-900 text-white" : "border-slate-200 bg-white text-slate-900 hover:border-brand-300"}`}>
            <span className={`flex shrink-0 items-center justify-center rounded-xl ${kompakt ? "h-9 w-9 sm:h-11 sm:w-11" : "h-11 w-11"} ${zap ? "bg-white/20" : "bg-brand-50 text-brand-700"}`}><Ikona className="h-5 w-5" /></span>
            <span className={`min-w-0 ${kompakt ? "w-full sm:w-auto sm:flex-1" : "flex-1"}`}><span className={`block font-bold ${kompakt ? "truncate text-[13px] sm:whitespace-normal sm:text-base" : "text-base"}`}>{p.nazev}</span>{p.pod && <span className={`truncate text-[13px] ${kompakt ? "hidden sm:block" : "block"} ${zap ? "text-white/80" : "text-slate-500"}`}>{p.pod}</span>}</span>
          </button>
        );
      })}
    </div>
  );
}

async function post(body) {
  const r = await apiFetch("/api/skoleni-materialy", { method: "POST", body: JSON.stringify(body) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
  return j;
}
const krestni = (j) => String(j || "").split(" ")[0];

function MaterialModal({ m, vychozi, kategorie, testy, onClose, onDone }) {
  const [f, setF] = useState({ parent_id: m?.parent_id || vychozi?.parent_id || "", kategorie: m?.kategorie || vychozi?.kategorie || kategorie[0] || "", nazev: m?.nazev || "", typ: m?.typ || "video", url: m?.url || "", url_pc: m?.url_pc || "", delka: m?.delka || "", popis: m?.popis || "", pristup: m?.pristup || "", prepis: m?.prepis || "", test_skoleni_id: m?.test_skoleni_id || "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  async function ulozit() {
    setBusy(true);
    try { await post({ akce: "ulozit", id: m?.id, ...f }); toast("Uloženo.", "success"); onDone(); onClose(); }
    catch (e) { toast(e.message, "error"); } finally { setBusy(false); }
  }
  return (
    <Modal open onClose={onClose} size="sm" plnaHlavicka
      header={<HlavickaOkna ikona={GraduationCap} nazev={m ? "Upravit položku" : vychozi?.parent_id ? "Přidat přílohu" : vychozi?.kategorie ? "Přidat modul" : "Nové školení"} onClose={onClose} />}
      footer={<button type="button" className="btn btn-primary w-full" disabled={busy || !f.nazev.trim() || !f.kategorie.trim()} onClick={ulozit}>{busy ? "Ukládám…" : "Uložit"}</button>}>
      <div className="space-y-3">
        <label className="block"><span className={POPISEK}>Kategorie *</span>
          <input className="field w-full" list="skoleni-kategorie" value={f.kategorie} onChange={(e) => set("kategorie", e.target.value)} />
          <datalist id="skoleni-kategorie">{kategorie.map((k) => <option key={k} value={k} />)}</datalist>
        </label>
        <label className="block"><span className={POPISEK}>Název *</span><input className="field w-full" value={f.nazev} onChange={(e) => set("nazev", e.target.value)} /></label>
        <div><span className={POPISEK}>Typ</span>
          <div className="flex flex-wrap gap-2">{Object.keys(TYP_PIL).map((t) => (
            <button key={t} type="button" aria-pressed={f.typ === t} onClick={() => set("typ", t)}
              className={`min-h-[44px] rounded-full border px-3.5 text-sm font-bold ${f.typ === t ? "border-brand-300 bg-brand-100 text-brand-deep" : "border-slate-200 bg-white text-slate-600"}`}>{TYP_PIL[t].text}</button>
          ))}</div>
        </div>
        <label className="block"><span className={POPISEK}>Odkaz (video, prezentace, dokument)</span><input className="field w-full" value={f.url} onChange={(e) => set("url", e.target.value)} placeholder="https://" /></label>
        <label className="block"><span className={POPISEK}>Odkaz na video pro počítač (volitelné, pak se v okně školení objeví přepínač Mobil / PC)</span><input className="field w-full" value={f.url_pc} onChange={(e) => set("url_pc", e.target.value)} placeholder="https://" /></label>
        <label className="block"><span className={POPISEK}>Délka</span><input className="field w-full" value={f.delka} onChange={(e) => set("delka", e.target.value)} placeholder="Např. 6 min, 14 snímků, PDF 18 stran" /></label>
        <label className="block"><span className={POPISEK}>Popis</span><textarea className="field w-full" rows={2} value={f.popis} onChange={(e) => set("popis", e.target.value)} /></label>
        <label className="block"><span className={POPISEK}>Přístupové údaje (zobrazí se trenérům zvýrazněně)</span><textarea className="field w-full" rows={2} value={f.pristup} onChange={(e) => set("pristup", e.target.value)} placeholder="Např. Heslo k notebooku: ..." /></label>
        <label className="block"><span className={POPISEK}>Textový přepis pro AI (z něj odpovídá Nápověda trenéra, vždy podle aktuálního znění)</span><textarea className="field w-full" rows={6} value={f.prepis} onChange={(e) => set("prepis", e.target.value)} placeholder="Celé znění toho, co se v modulu říká a ukazuje. Když něco změníš ve videu, uprav i tady." /></label>
        <label className="block"><span className={POPISEK}>Navazující test</span>
          <select className="field w-full" value={f.test_skoleni_id} onChange={(e) => set("test_skoleni_id", e.target.value)}>
            <option value="">bez testu</option>
            {testy.map((t) => <option key={t.id} value={t.id}>{t.nazev}</option>)}
          </select>
        </label>
      </div>
    </Modal>
  );
}

function PridelitModal({ m: mVstup, kategorie, polozky, onClose, onDone }) {
  // Celé školení: přidělení platí pro všechny jeho položky najednou. Předvyplní se ti, kdo mají vše.
  const m = useMemo(() => {
    if (!kategorie) return mVstup;
    const prvni = polozky[0]?.lide || [];
    const vse = prvni.filter((l) => polozky.every((p) => (p.lide || []).some((x) => x.person_id === l.person_id)));
    return { id: null, nazev: kategorie, lide: vse };
  }, [kategorie, polozky, mVstup]);
  const { data } = useApiData("/api/hr-list-people?filter=vse&status=aktivni");
  const people = data?.people || [];
  const puvodni = useMemo(() => new Set((m.lide || []).map((l) => l.person_id)), [m]);
  const [vybrani, setVybrani] = useState(() => new Set((m.lide || []).map((l) => l.person_id)));
  const [hledat, setHledat] = useState("");
  const [busy, setBusy] = useState(false);
  const filtrovani = people.filter((p) => !hledat.trim() || `${p.display_name} ${p.pozice || ""}`.toLowerCase().includes(hledat.trim().toLowerCase()));
  const toggle = (id) => setVybrani((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  async function ulozit() {
    setBusy(true);
    try {
      const nove = people.filter((p) => vybrani.has(p.id) && !puvodni.has(p.id)).map((p) => ({ id: p.id, jmeno: p.display_name }));
      if (kategorie) {
        // Znovu i pro ty, kdo už něco mají: doplní se chybějící položky.
        const vsichni = people.filter((p) => vybrani.has(p.id)).map((p) => ({ id: p.id, jmeno: p.display_name }));
        if (vsichni.length) await post({ akce: "pridelit_skoleni", kategorie, lide: vsichni });
        for (const pid of puvodni) if (!vybrani.has(pid)) await post({ akce: "odebrat_skoleni", kategorie, person_id: pid });
      } else {
        if (nove.length) await post({ akce: "pridelit", id: m.id, lide: nove });
        for (const pid of puvodni) if (!vybrani.has(pid)) await post({ akce: "odebrat", id: m.id, person_id: pid });
      }
      toast("Přidělení uloženo.", "success"); onDone(); onClose();
    } catch (e) { toast(e.message, "error"); } finally { setBusy(false); }
  }
  return (
    <Modal open onClose={onClose} size="sm" plnaHlavicka
      header={<HlavickaOkna ikona={UserPlus} nazev={kategorie ? "Přidělit celé školení" : "Přidělit modul"} popis={m.nazev} onClose={onClose} />}
      footer={<button type="button" className="btn btn-primary w-full" disabled={busy} onClick={ulozit}>{busy ? "Ukládám…" : `Uložit (${vybrani.size})`}</button>}>
      <div className="relative mb-3">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input className="field w-full pl-9" value={hledat} onChange={(e) => setHledat(e.target.value)} placeholder="Hledat člověka" aria-label="Hledat člověka" />
      </div>
      <div className="max-h-[50vh] space-y-1 overflow-y-auto">
        {filtrovani.map((p) => {
          const zap = vybrani.has(p.id);
          const hotovo = (m.lide || []).find((l) => l.person_id === p.id)?.hotovo_at;
          return (
            <button key={p.id} type="button" onClick={() => toggle(p.id)} aria-pressed={zap}
              className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left ${zap ? "bg-brand-50" : "hover:bg-slate-50"}`} style={{ minHeight: 48 }}>
              <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md border-2 ${zap ? "border-brand bg-brand text-white" : "border-slate-300 bg-white"}`}>{zap && <Check className="h-3.5 w-3.5" />}</span>
              <span className="min-w-0 flex-1"><span className="block truncate text-sm font-semibold text-slate-800 demo-sensitive">{p.display_name}</span>{p.pozice && <span className="block truncate text-xs text-slate-500">{p.pozice}</span>}</span>
              {hotovo && <Pil ton="ok" casti="hotovo" mala />}
            </button>
          );
        })}
      </div>
    </Modal>
  );
}

const sklon = (n, a, b, c) => (n === 1 ? a : n >= 2 && n <= 4 ? b : c);

const STAVY = [
  { key: "vse", label: "Vše" },
  { key: "rozpracovane", label: "Rozpracované" },
  { key: "nezacate", label: "Nezačaté" },
  { key: "hotove", label: "Hotové" },
];
const bezDiakritiky = (t) => String(t || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const MRIZKA_RADKU = "grid grid-cols-[44px_minmax(0,1fr)_150px_170px_112px_44px] items-center gap-3";

/** Jedno školení = jeden řádek. Na počítači tabulka, na telefonu karta .polozka. */
function RadekSkoleni({ r, uzka, onOtevrit }) {
  const pillModuly = <Stitek>{r.moduly} {sklon(r.moduly, "modul", "moduly", "modulů")}</Stitek>;
  const pillPrilohy = r.priloh > 0 ? <Stitek>{r.priloh} {sklon(r.priloh, "příloha", "přílohy", "příloh")}</Stitek> : null;
  const postup = !r.lide.length
    ? <span className="text-xs text-slate-500">Nikomu nepřiděleno</span>
    : r.stav === "hotove"
      ? <Stitek ton="ok">Hotovo</Stitek>
      : (
        <div className="flex min-w-0 items-center gap-2">
          <div className="h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-brand-100" role="progressbar" aria-valuenow={r.procent} aria-valuemin={0} aria-valuemax={100}>
            <div className="h-full rounded-full bg-brand" style={{ width: `${r.procent}%` }} />
          </div>
          <span className="w-10 shrink-0 text-right text-sm font-semibold tabular-nums text-slate-800">{r.procent} %</span>
        </div>
      );
  const tlacitko = (
    <button type="button" onClick={onOtevrit} className="btn-ikona" aria-label={`Otevřít školení ${r.kat}`} title="Otevřít">
      <ArrowUpRight className="h-5 w-5" />
    </button>
  );
  const ikona = <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand-deep"><Play className="h-5 w-5" /></span>;
  if (uzka) {
    return (
      <div className="polozka mt-2 flex cursor-pointer items-center gap-3" onClick={onOtevrit}>
        {ikona}
        <div className="min-w-0 flex-1">
          <div className="text-base font-bold text-slate-900">{r.kat}</div>
          <div className="mt-1.5 flex flex-wrap gap-1.5">{pillModuly}{pillPrilohy}{r.lide.length > 0 && <Stitek>{r.lide.length} {sklon(r.lide.length, "člověk", "lidé", "lidí")}</Stitek>}</div>
          <div className="mt-2">{postup}</div>
        </div>
        {tlacitko}
      </div>
    );
  }
  return (
    <div className={`${MRIZKA_RADKU} cursor-pointer border-t border-slate-100 px-4 py-3 transition hover:bg-brand-50/60`} onClick={onOtevrit}>
      {ikona}
      <div className="min-w-0">
        <div className="truncate text-base font-bold text-slate-900" title={r.kat}>{r.kat}</div>
        <div className="mt-1 flex flex-wrap gap-1.5">{pillModuly}{pillPrilohy}</div>
      </div>
      <div className="min-w-0 truncate text-sm text-slate-600 demo-sensitive" title={r.lide.map((l) => l.jmeno).join(", ")}>
        {r.lide.length ? r.lide.slice(0, 2).map((l) => krestni(l.jmeno)).join(", ") + (r.lide.length > 2 ? ` +${r.lide.length - 2}` : "") : "nikdo"}
      </div>
      <div title={r.lide.map((l) => `${krestni(l.jmeno)} ${l.hotovo}/${r.moduly}`).join(", ")}>{postup}</div>
      <div className="whitespace-nowrap text-sm tabular-nums text-slate-600">{r.zmena ? datumCz(r.zmena) : ""}</div>
      {tlacitko}
    </div>
  );
}

export default function SkoleniMaterialy() {
  const { data, loading, refetch } = useApiData("/api/skoleni-materialy", { bezKese: true });
  const [modal, setModal] = useState(null); // { typ: "material"|"pridelit", m, vychozi, kategorie }
  const [okno, setOkno] = useState(null); // název školení otevřeného v okně
  const materialy = data?.materialy || [];
  const kategorie = data?.kategorie || [];

  const skupiny = useMemo(() => {
    const m = new Map();
    for (const x of materialy) { if (!m.has(x.kategorie)) m.set(x.kategorie, []); m.get(x.kategorie).push(x); }
    return [...m.entries()];
  }, [materialy]);
  const uzka = useUzkaObrazovka();
  const [hledat, setHledat] = useState("");
  const [stav, setStav] = useState("vse");
  const radky = useMemo(() => skupiny.map(([kat, polozky]) => {
    const moduly = slozModuly(polozky);
    const lideMap = new Map();
    for (const p of polozky) for (const l of p.lide || []) if (!lideMap.has(l.person_id)) lideMap.set(l.person_id, l.person_name);
    const lide = [...lideMap.entries()].map(([pid, jmeno]) => ({ pid, jmeno, hotovo: moduly.filter((m) => (m.lide || []).some((l) => l.person_id === pid && l.hotovo_at)).length }));
    const celkem = moduly.length * lide.length;
    const hotovo = lide.reduce((a, l) => a + l.hotovo, 0);
    const procent = celkem ? Math.round((hotovo / celkem) * 100) : 0;
    const st = !lide.length || hotovo === 0 ? "nezacate" : hotovo >= celkem ? "hotove" : "rozpracovane";
    const zmena = polozky.reduce((x, p) => (p.updated_at > x ? p.updated_at : x), "");
    return { kat, moduly: moduly.length, priloh: polozky.length - moduly.length, lide, procent, stav: st, zmena };
  }), [skupiny]);
  const radkyFiltr = radky.filter((r) => (stav === "vse" || r.stav === stav)
    && (!hledat.trim() || bezDiakritiky(`${r.kat} ${r.lide.map((l) => l.jmeno).join(" ")}`).includes(bezDiakritiky(hledat.trim()))));
  const oknoPolozky = skupiny.find(([k]) => k === okno)?.[1];
  useEffect(() => { if (okno && data && !oknoPolozky) setOkno(null); }, [okno, data, oknoPolozky]);

  async function smazat(m) {
    const ok = await confirmDialog({ title: "Smazat položku?", description: `„${m.nazev}“ zmizí ze seznamu i lidem, kterým je přidělená.`, confirmLabel: "Smazat", cancelLabel: "Zrušit", variant: "danger" });
    if (!ok) return;
    try { await post({ akce: "smazat", id: m.id }); refetch(); } catch (e) { toast(e.message, "error"); }
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex min-w-0 flex-1 items-start gap-2 rounded-xl bg-brand-50 px-3 py-2.5 text-[13px] font-semibold text-brand-deep">
          <GraduationCap className="mt-0.5 h-4 w-4 shrink-0" />
          <span>Školení se otevře v okně přes celou obrazovku, modul po modulu. Přidělený ho uvidí v Moje školení a postup se mu počítá sám.</span>
        </div>
        <button type="button" className="btn btn-primary" onClick={() => setModal({ typ: "material", m: null })}><Plus className="h-5 w-5" />Nové školení</button>
      </div>
      {loading && !data ? <div className="h-24 animate-pulse rounded-2xl bg-brand-light" />
        : !skupiny.length ? <div className="glass"><EmptyState icon={GraduationCap} title="Zatím žádné školení" hint="Přidej první video, prezentaci nebo dokument." /></div>
          : (
            <>
              <PruhFiltru zapnuto={stav !== "vse" || !!hledat} onZrusit={() => { setStav("vse"); setHledat(""); }}>
                <div className={`flex gap-2 ${uzka ? "flex-col" : "items-center"}`}>
                  <div className="relative min-w-0 flex-1">
                    <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                    <input className="field w-full pl-9" value={hledat} onChange={(e) => setHledat(e.target.value)} placeholder="Hledat školení nebo člověka" aria-label="Hledat školení nebo člověka" />
                  </div>
                  <RozbalovaciVyber stitek="Stav" items={STAVY} value={stav} onChange={setStav} className={uzka ? "" : "w-[260px] shrink-0"} aria-label="Stav školení" />
                </div>
              </PruhFiltru>
              <KartaSeznam ikona={List} title="Seznam školení" odznak={radkyFiltr.length}>
                {!uzka && radkyFiltr.length > 0 && (
                  <div className={`${MRIZKA_RADKU} px-4 pb-1 pt-3 text-xs font-semibold uppercase tracking-wide text-slate-500`}>
                    <span /><span>Školení</span><span>Lidé</span><span>Postup</span><span>Změněno</span><span />
                  </div>
                )}
                <div className={uzka ? "px-3 pb-3 pt-1" : "pb-1"}>
                  {radkyFiltr.length
                    ? radkyFiltr.map((r) => <RadekSkoleni key={r.kat} r={r} uzka={uzka} onOtevrit={() => setOkno(r.kat)} />)
                    : <EmptyState icon={Search} title="Nic nenalezeno" hint="Zkus jiné hledání nebo stav." />}
                </div>
              </KartaSeznam>
            </>
          )}
      {oknoPolozky && (
        <SkoleniOkno nazev={okno} moduly={slozModuly(oknoPolozky)} rezim="sprava" ztlumit={!!modal} onClose={() => setOkno(null)}
          sprava={{
            onUpravit: (m) => setModal({ typ: "material", m }),
            onPridelit: (m) => setModal({ typ: "pridelit", m }),
            onSmazat: smazat,
            onPridatPrilohu: (m) => setModal({ typ: "material", m: null, vychozi: { kategorie: okno, parent_id: m.id } }),
            onPridatModul: () => setModal({ typ: "material", m: null, vychozi: { kategorie: okno } }),
            onPridelitSkoleni: () => setModal({ typ: "pridelit", kategorie: okno }),
          }} />
      )}
      {modal?.typ === "material" && <MaterialModal m={modal.m} vychozi={modal.vychozi} kategorie={kategorie} testy={data?.testy || []} onClose={() => setModal(null)} onDone={refetch} />}
      {modal?.typ === "pridelit" && <PridelitModal m={modal.m} kategorie={modal.kategorie} polozky={modal.kategorie ? (skupiny.find(([k]) => k === modal.kategorie)?.[1] || []) : []} onClose={() => setModal(null)} onDone={refetch} />}
    </div>
  );
}
